__turbopack_context__.v({
  "active": "DeliveryLeftItem-module__mRa3Ca__active",
  "colorIndicator": "DeliveryLeftItem-module__mRa3Ca__colorIndicator",
  "deliveryLeftItem": "DeliveryLeftItem-module__mRa3Ca__deliveryLeftItem",
});
